import React from "react";
import LegalLayout from "@/components/LegalLayout";
import useSeo from "@/hooks/useSeo";
import { openCookieSettings } from "@/components/CookieConsent";

export default function DatenschutzPage() {
  useSeo({
    title: "Datenschutz",
    description:
      "Datenschutzerklärung von Alex Buchner Health gemäß DS-GVO.",
    path: "/datenschutz",
  });

  return (
    <LegalLayout title="Datenschutzerklärung">
      <p>
        Der Schutz Ihrer personenbezogenen Daten ist uns besonders wichtig. Sie
        können unsere Webseite grundsätzlich nutzen, ohne uns personenbezogene
        Daten preiszugeben. Sofern Sie speziellere Dienste in Anspruch nehmen
        (z. B. das Kontaktformular), kann eine Verarbeitung Ihrer
        personenbezogenen Daten erforderlich sein. Wir halten uns dabei stets
        an die geltenden Datenschutzgesetze (insbesondere DS-GVO und BDSG).
      </p>

      <section data-testid="datenschutz-verantwortlicher">
        <h2 className="font-display text-xl font-bold mt-8 mb-3">
          1. Verantwortlicher
        </h2>
        <p>
          Verantwortlicher im Sinne der Datenschutz-Grundverordnung und
          sonstiger geltender Datenschutzgesetze ist:
        </p>
        <p>
          Alexander Buchner
          <br />
          Froschsee 27
          <br />
          83324 Ruhpolding
          <br />
          Tel.: +49 175 1515 725
          <br />
          E-Mail:{" "}
          <a
            href="mailto:info@alex-buchner-health.de"
            className="text-[#2E89C4] hover:underline"
          >
            info@alex-buchner-health.de
          </a>
          <br />
          Website:{" "}
          <a
            href="https://www.alex-buchner-health.de"
            className="text-[#2E89C4] hover:underline"
            target="_blank"
            rel="noreferrer"
          >
            www.alex-buchner-health.de
          </a>
        </p>
      </section>

      <section data-testid="datenschutz-server-logs">
        <h2 className="font-display text-xl font-bold mt-8 mb-3">
          2. Erfassung allgemeiner Daten und Informationen
        </h2>
        <p>
          Unsere Webseite erfasst mit jedem Aufruf durch eine betroffene Person
          oder ein automatisiertes System eine Reihe allgemeiner Daten und
          Informationen. Diese werden in den Logfiles des Servers gespeichert.
          Erfasst werden können u. a. (1) verwendete Browsertypen und Versionen,
          (2) das vom zugreifenden System verwendete Betriebssystem,
          (3) die Webseite, von der ein zugreifendes System auf unsere Webseite
          gelangt (Referrer), (4) die Unterseiten, die über ein zugreifendes
          System angesteuert werden, (5) Datum und Uhrzeit des Zugriffs,
          (6) eine Internet-Protokoll-Adresse (IP-Adresse), (7) der
          Internet-Service-Provider sowie (8) sonstige ähnliche Daten und
          Informationen, die der Gefahrenabwehr dienen.
        </p>
        <p>
          Zweck der Verarbeitung ist die Gefahrenabwehr und Gewährleistung der
          IT-Sicherheit. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DS-GVO. Unser
          berechtigtes Interesse ist der Schutz unserer informationstechnologischen
          Systeme.
        </p>
      </section>

      <section data-testid="datenschutz-contact-form">
        <h2 className="font-display text-xl font-bold mt-8 mb-3">
          3. Kontaktformular und elektronische Kontaktaufnahme
        </h2>
        <p>
          Auf unserer Webseite befindet sich ein Kontaktformular, über das Sie
          uns elektronisch eine Anfrage zukommen lassen können. Sofern Sie das
          Formular nutzen, werden die von Ihnen übermittelten personenbezogenen
          Daten (Name, E-Mail-Adresse, Nachricht) automatisch gespeichert und
          zur Bearbeitung Ihrer Anfrage sowie zur Kontaktaufnahme mit Ihnen
          verarbeitet. Eine Weitergabe an Dritte erfolgt nicht.
        </p>
        <p>
          Rechtsgrundlage für die Verarbeitung ist Ihre Einwilligung gemäß
          Art. 6 Abs. 1 lit. a DS-GVO sowie ggf. Art. 6 Abs. 1 lit. b DS-GVO
          (vorvertragliche Maßnahmen). Sie können Ihre Einwilligung jederzeit
          mit Wirkung für die Zukunft widerrufen, indem Sie eine E-Mail an{" "}
          <a
            href="mailto:info@alex-buchner-health.de"
            className="text-[#2E89C4] hover:underline"
          >
            info@alex-buchner-health.de
          </a>{" "}
          senden.
        </p>
      </section>

      <section data-testid="datenschutz-cookies">
        <h2 className="font-display text-xl font-bold mt-8 mb-3">
          4. Cookies und Einwilligungsmanagement
        </h2>
        <p>
          Unsere Webseite verwendet Cookies. Beim Aufruf der Seite wird Ihnen
          ein Consent-Banner angezeigt, über das Sie selbst entscheiden können,
          welche Kategorien von Cookies Sie zulassen möchten. Technisch
          notwendige Cookies sind dabei immer aktiv, da sie für den Betrieb der
          Seite erforderlich sind. Optional sind die Kategorien „Statistik" und
          „Marketing", die nur nach Ihrer ausdrücklichen Einwilligung gesetzt
          werden.
        </p>
        <p>
          Ihre Einwilligung wird lokal im Browser (LocalStorage) gespeichert,
          inklusive Zeitpunkt und Version, um den Nachweis Ihrer Auswahl zu
          ermöglichen. Sie können Ihre Auswahl jederzeit anpassen oder
          widerrufen, indem Sie{" "}
          <button
            type="button"
            data-testid="open-cookie-settings-link"
            onClick={openCookieSettings}
            className="text-[#2E89C4] hover:underline"
          >
            hier Ihre Cookie-Einstellungen öffnen
          </button>
          .
        </p>
      </section>

      <section data-testid="datenschutz-storage-duration">
        <h2 className="font-display text-xl font-bold mt-8 mb-3">
          5. Speicherdauer
        </h2>
        <p>
          Wir verarbeiten und speichern personenbezogene Daten nur für den
          Zeitraum, der zur Erreichung des Speicherungszwecks erforderlich ist
          oder sofern dies durch gesetzliche Vorschriften vorgesehen wurde.
          Entfällt der Speicherungszweck oder läuft eine vorgeschriebene
          Speicherfrist ab, werden die Daten routinemäßig gelöscht.
        </p>
      </section>

      <section data-testid="datenschutz-rights">
        <h2 className="font-display text-xl font-bold mt-8 mb-3">
          6. Ihre Rechte als betroffene Person
        </h2>
        <p>Sie haben uns gegenüber folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-2">
          <li>Recht auf Auskunft (Art. 15 DS-GVO)</li>
          <li>Recht auf Berichtigung (Art. 16 DS-GVO)</li>
          <li>Recht auf Löschung (Art. 17 DS-GVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DS-GVO)</li>
          <li>Recht auf Datenübertragbarkeit (Art. 20 DS-GVO)</li>
          <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DS-GVO)</li>
          <li>Recht auf Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DS-GVO)</li>
          <li>
            Recht auf Beschwerde bei einer Aufsichtsbehörde (Art. 77 DS-GVO).
            Zuständig in Bayern: Bayerisches Landesamt für Datenschutzaufsicht
            (BayLDA), Promenade 18, 91522 Ansbach.
          </li>
        </ul>
        <p className="mt-3">
          Um eines dieser Rechte auszuüben, wenden Sie sich bitte formlos an
          die oben angegebene E-Mail-Adresse.
        </p>
      </section>

      <section data-testid="datenschutz-third-countries">
        <h2 className="font-display text-xl font-bold mt-8 mb-3">
          7. Drittlandübermittlungen
        </h2>
        <p>
          Eine Übermittlung Ihrer personenbezogenen Daten an ein Drittland (z. B.
          USA) findet nur dann statt, wenn dies gesetzlich vorgesehen ist, Sie
          eingewilligt haben oder geeignete Garantien gemäß Art. 46 DS-GVO
          (z. B. EU-Standardvertragsklauseln) bestehen.
        </p>
      </section>

      <section data-testid="datenschutz-required">
        <h2 className="font-display text-xl font-bold mt-8 mb-3">
          8. Bereitstellung personenbezogener Daten
        </h2>
        <p>
          Die Bereitstellung personenbezogener Daten ist weder gesetzlich noch
          vertraglich vorgeschrieben. Sie sind nicht verpflichtet,
          personenbezogene Daten bereitzustellen. Die Nichtbereitstellung hätte
          jedoch zur Folge, dass eine Bearbeitung Ihrer Anfrage nicht möglich
          wäre.
        </p>
      </section>

      <section data-testid="datenschutz-no-profiling">
        <h2 className="font-display text-xl font-bold mt-8 mb-3">
          9. Keine automatisierte Entscheidungsfindung
        </h2>
        <p>
          Wir verzichten auf eine automatisierte Entscheidungsfindung sowie auf
          Profiling.
        </p>
      </section>
    </LegalLayout>
  );
}
